export default {
      id: "depth-4-usage",
      viewBox: "0 0 101 15",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#depth-4",
      toString: function () {
        return this.url;
      }
    }